import { useContext } from "react";
import { DragDropContext } from "./DragDropProvider";

const Droppable = ({ children, droppableId }) => {
    const {
        hoveringDroppableId
    } = useContext(DragDropContext);

  const provided = {
    droppableProps: {
      "data-droppable-id": droppableId,
    },
  };
  const snapshot = {
    isDraggingOver: hoveringDroppableId === droppableId,
  };

  return children(provided, snapshot);
};

export default Droppable;
